import { BillingDetails } from 'src/types/payment';
import api from './axiosConfig';

export const cancelAddOn = async (
  orgId: string,
  coreSubscriptionId: string,
  itemSubscriptionId: string,
  reasons: string[],
  comments: string
) => {
  try {
    const cancelProductResponse = await api({
      method: 'DELETE',
      url: `/v2/organization/${orgId}/subscription/${coreSubscriptionId}/addOn/${itemSubscriptionId}`,
      data: {
        reasons,
        comments,
      },
    });
    if (cancelProductResponse && cancelProductResponse.data && cancelProductResponse.data?.item) {
      return {
        error: false,
      };
    } else {
      return {
        error: true,
      };
    }
  } catch (e) {
    console.error(e);
    return false;
  }
};

export const addAddOn = async (orgId: string, coreSubscriptionId: string, priceIds: string[]) => {
  try {
    const addProductResponse = await api({
      method: 'POST',
      url: `/v2/organization/${orgId}/subscription/${coreSubscriptionId}/addOns`,
      data: {
        priceIds: priceIds,
      },
    });
    if (addProductResponse && addProductResponse.data && addProductResponse.data?.items) {
      return {
        error: false,
      };
    }
  } catch (e) {
    console.error(e);
    return {
      error: true,
    };
  }
};

export const updateSubscription = async (
  orgId: string,
  coreSubscriptionId: string,
  priceIds: string[],
  billingDetails: BillingDetails
) => {
  try {
    const addProductResponse = await api({
      method: 'PUT',
      url: `/v2/organization/${orgId}/subscription/${coreSubscriptionId}`,
      data: {
        billing: {
          country: billingDetails.address.country || '',
          state: billingDetails.address.state || '',
        },
        priceIds: priceIds,
        promoCode: '',
      },
    });
    if (addProductResponse && addProductResponse.data && addProductResponse.data?.subscription) {
      return {
        error: false,
      };
    }
  } catch (e) {
    console.error(e);
    return {
      error: true,
    };
  }
};

export const cancelSubscription = async (
  orgId: string,
  coreSubscriptionId: string,
  reasons: string[],
  comments: string
) => {
  try {
    const addProductResponse = await api({
      method: 'DELETE',
      url: `/v2/organization/${orgId}/subscription/${coreSubscriptionId}`,
      data: {
        reasons,
        comments,
      },
    });
    if (addProductResponse && addProductResponse.data && addProductResponse.data?.subscription) {
      return {
        error: false,
      };
    }
  } catch (e) {
    console.error(e);
    return {
      error: true,
    };
  }
};
